var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 6.34315 0 3.51472 1.63012 1.75736C3.26023 0 5.88387 0 11.1311 0C16.3784 0 19.002 0 20.6322 1.75736C22.2623 3.51472 22.2623 6.34315 22.2623 12C22.2623 17.6569 22.2623 20.4853 20.6322 22.2426C19.002 24 16.3784 24 11.1311 24C5.88387 24 3.26023 24 1.63012 22.2426C0 20.4853 0 17.6569 0 12Z",
    fill: "url(#paint0_linear_3365_6616)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63016 22.3189C3.26033 24.0009 5.88404 24.0009 11.1315 24.0009C16.3789 24.0009 19.0026 24.0009 20.6327 22.3189C22.1433 20.7603 22.2541 18.3215 22.2623 13.6641H18.7451C17.7375 13.6641 17.2337 13.6641 16.7909 13.8742C16.348 14.0844 16.0202 14.479 15.3644 15.2684L15.3644 15.2684L14.6905 16.0796C14.0348 16.869 13.7069 17.2636 13.2641 17.4738C12.8212 17.684 12.3174 17.6839 11.3098 17.6839H10.9531C9.94548 17.6839 9.44168 17.684 8.99884 17.4738C8.556 17.2636 8.22814 16.869 7.57241 16.0796L6.89848 15.2684C6.24275 14.479 5.91489 14.0844 5.47205 13.8742C5.02921 13.6641 4.52542 13.6641 3.51783 13.6641H0C0.00812959 18.3215 0.11959 20.7603 1.63016 22.3189Z",
    fill: "#FFF3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6615 9.33013C11.5208 9.47079 11.33 9.5498 11.1311 9.5498C10.9322 9.5498 10.7415 9.47079 10.6008 9.33013L7.3008 6.03014C7.00791 5.73724 7.00791 5.26237 7.3008 4.96948C7.59369 4.67658 8.06857 4.67658 8.36146 4.96947L10.3811 6.98914L10.3811 0.000236895C10.6242 0 10.8741 0 11.1309 0C11.3879 0 11.6379 0 11.8811 0.000237274V6.98914L13.9008 4.96947C14.1937 4.67658 14.6686 4.67658 14.9615 4.96947C15.2544 5.26237 15.2544 5.73724 14.9615 6.03013L11.6615 9.33013Z",
    fill: "#FFF3D3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3365_6616",
    x1: 2.33395,
    y1: 1.79301,
    x2: 19.1491,
    y2: 15.4421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DC90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3B872"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.25b7d4202ce53c845a9e9d3dfb73b59a.svg";
export { ForwardRef as ReactComponent };